(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brutalist-cart"]) return;
  try {
    
  // Quantity selector functionality
  document.addEventListener('DOMContentLoaded', function() {
    const quantityInputs = document.querySelectorAll('.brutalist-cart__quantity-value');
    const minusButtons = document.querySelectorAll('[data-quantity-update="minus"]');
    const plusButtons = document.querySelectorAll('[data-quantity-update="plus"]');
    const removeButtons = document.querySelectorAll('[data-item-remove]');
    
    // Helper function to update cart
    async function updateCart(id, quantity) {
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: id,
            quantity: quantity
          })
        });
        
        if (response.ok) {
          // Reload the page to reflect changes
          window.location.reload();
        }
      } catch (error) {
        console.error('Error updating cart:', error);
      }
    }
    
    // Quantity minus buttons
    if (minusButtons) {
      minusButtons.forEach(button => {
        button.addEventListener('click', function() {
          const itemId = this.getAttribute('data-item-id');
          const input = document.querySelector(`.brutalist-cart__quantity-value[data-item-id="${itemId}"]`);
          
          let quantity = parseInt(input.value);
          
          if (quantity > 0) {
            quantity -= 1;
            input.value = quantity;
            updateCart(itemId, quantity);
          }
        });
      });
    }
    
    // Quantity plus buttons
    if (plusButtons) {
      plusButtons.forEach(button => {
        button.addEventListener('click', function() {
          const itemId = this.getAttribute('data-item-id');
          const input = document.querySelector(`.brutalist-cart__quantity-value[data-item-id="${itemId}"]`);
          
          let quantity = parseInt(input.value);
          quantity += 1;
          input.value = quantity;
          updateCart(itemId, quantity);
        });
      });
    }
    
    // Quantity inputs
    if (quantityInputs) {
      quantityInputs.forEach(input => {
        input.addEventListener('change', function() {
          const itemId = this.getAttribute('data-item-id');
          const quantity = parseInt(this.value);
          
          if (quantity >= 0) {
            updateCart(itemId, quantity);
          }
        });
      });
    }
    
    // Remove buttons
    if (removeButtons) {
      removeButtons.forEach(button => {
        button.addEventListener('click', function() {
          const itemId = this.getAttribute('data-item-remove');
          updateCart(itemId, 0);
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brutalist-collection-grid"] && !Shopify.designMode) return;
  try {
    
// Set up sorting functionality
document.addEventListener('DOMContentLoaded', function() {
  const sortBySelect = document.getElementById('SortBy');
  if (!sortBySelect) return;
  
  // Set initial value based on URL parameters
  const urlParams = new URLSearchParams(window.location.search);
  const sortBy = urlParams.get('sort_by');
  if (sortBy) {
    sortBySelect.value = sortBy;
  }
  
  // Add change event listener
  sortBySelect.addEventListener('change', function() {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', this.value);
    window.location.href = url.toString();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content-elsked"] && !Shopify.designMode) return;
  try {
    
  // Quantity selector functionality
  document.addEventListener('DOMContentLoaded', function() {
    const quantityInput = document.querySelector('.product-elsked__quantity-value');
    const minusButton = document.querySelector('[data-quantity-minus]');
    const plusButton = document.querySelector('[data-quantity-plus]');
    
    if (quantityInput && minusButton && plusButton) {
      minusButton.addEventListener('click', function() {
        const currentValue = parseInt(quantityInput.value);
        if (currentValue > 1) {
          quantityInput.value = currentValue - 1;
        }
      });
      
      plusButton.addEventListener('click', function() {
        const currentValue = parseInt(quantityInput.value);
        quantityInput.value = currentValue + 1;
      });
    }
    
    // Media gallery controls
    const mediaGallery = document.querySelector('.product-elsked__media-gallery');
    const prevButton = document.querySelector('.product-elsked__media-prev');
    const nextButton = document.querySelector('.product-elsked__media-next');
    
    if (mediaGallery && prevButton && nextButton) {
      let currentPage = 0;
      const mediaItems = document.querySelectorAll('.product-elsked__media-item');
      const itemsPerPage = 4;
      const totalPages = Math.ceil(mediaItems.length / itemsPerPage);
      
      function updateGallery() {
        mediaItems.forEach((item, index) => {
          const start = currentPage * itemsPerPage;
          const end = start + itemsPerPage;
          
          if (index >= start && index < end) {
            item.style.display = 'block';
          } else {
            item.style.display = 'none';
          }
        });
      }
      
      prevButton.addEventListener('click', function() {
        currentPage = (currentPage - 1 + totalPages) % totalPages;
        updateGallery();
      });
      
      nextButton.addEventListener('click', function() {
        currentPage = (currentPage + 1) % totalPages;
        updateGallery();
      });
      
      updateGallery();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
